import { render, staticRenderFns } from "./creditoView.vue?vue&type=template&id=217d63db"
import script from "./creditoView.vue?vue&type=script&lang=js"
export * from "./creditoView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports